import { render, staticRenderFns } from "./studenteUscitaPiatti.vue?vue&type=template&id=772332df&"
import script from "./studenteUscitaPiatti.vue?vue&type=script&lang=js&"
export * from "./studenteUscitaPiatti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports